<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  .content-center
    .highlight-function-bar
      .page-tab
        ul.p-0.m-0.d-flex.justify-content-center
          li.flex-grow-1
            a.d-flex.justify-content-center.align-items-center(href='javascript:void(0);' @click="setMode(1)" :class="{'active': mode == 1}") {{ $t("ui.highlight") }}
          li.flex-grow-1
            a.d-flex.justify-content-center.align-items-center(href='javascript:void(0);' @click="setMode(0)" :class="{'active': mode == 0}")
              span.mr-1 {{ $t("ui.live") }}
              span.badge.badge-warning(v-if="this.liveTV.count") {{ this.liveTV.count }}
    template(v-if="mode == 0")
      // live now
      template(v-if="this.liveTV.count > 0")
        .filter-highlight-group
          .league-filter-group
            .all-wrapper
              a.all(href="javascript:void(0);" :class="{ 'active': selectedLiveNow == '0' }" @click="setLiveNow('0')") {{ $t("ui.all") }}
            .league-filter-wrapper
              ul.league-filter
                li.league-tab(v-for="item in liveSportsList" :class="{ 'active': selectedLiveNow == item }" @click="setLiveNow(item)")
                  img.league-logo(v-if="item != 41" :src="'images/icon-sport-svg/' + item + '.svg'")
                  img.league-logo(v-else :src="'images/icon-sport-svg/' + item + '.png'" style="height: 20px;")
                  span.mr-1 {{ sports[item] }}
                  span.badge.badge-info(v-if="liveTV.schedule") {{ liveTV.schedule[item].length }}
        #highlight.highlight-content
          template(v-for="(group, index, count) in highlightList")
            template(v-for="(item, index) in group")
              .card
                .league-name(:id="'livenow-' + item.league_id + index" data-toggle='collapse' :data-target="'#livenow-' + item.match_id" :aria-expanded="count + index == 0" :aria-controls="'livenow-' + item.match_id")
                  img.league-logo(v-if="item.sports_type != 41" :src="'images/icon-sport-svg/' + item.sports_type + '.svg'")
                  img.league-logo(v-else :src="'images/icon-sport-svg/' + item.sports_type + '.png'" style="height: 20px;")
                  span {{ item.home_name_en }} VS {{ item.away_name_en }}
                  .pulse
                //- .collapse.show(:id="'livenow-' + item.match_id" :aria-labelledby="'livenow-' + item.league_id + index" data-parent='#highlight')
                .collapse.show(:id="'livenow-' + item.match_id" :aria-labelledby="'livenow-' + item.league_id + index")
                  .highlight-group
                    .live-video(:class="'sportsbg' + item.sports_type" @click="chooseMatch(item)")
                      template(v-if="event.match_id != item.match_id")
                        .d-flex.align-items-center.flex-grow-1.justify-content-center
                          .team-home.d-flex.align-items-center.justify-content-end
                            img.team-logo(:src="item.home_logo")
                            .team-name.text-right {{ item.home_name_en }}
                          .vs VS
                          .team-away.d-flex.align-items-center.justify-content-start
                            .team-name.text-left {{ item.away_name_en }}
                            img.team-logo(:src="item.away_logo")
                        .play-btn
                      template(v-else)
                        i.fa.fa-spinner.fa-spin(v-if="loader")
                        span(v-if="error") {{ error }}
                        .widget(:id="'widget-' + item.match_id")
                    .btn-highlight(@click="handleMore(item)")
                      | {{ $t("ui.view_odds") }}
                      i.far.fa-arrow-alt-circle-right.ml-1
      template(v-else)
        .message-empty
          .empty.text-center.mt-3
            i.fad.fa-exclamation-triangle
          p.no-message.text-center {{ $t("message.no_information_available") }}
    template(v-else)
      // highlight
      .filter-highlight-group
        .weekly-filter-group
          .all-wrapper
            a.all(href="javascript:void(0);" :class="{ 'active': selectedDate == null }" @click="setDated()") {{ $t("ui.all") }}
          .weekly-filter-wrapper
            ul.weekly-filter
              li.weekly-tab(v-for="item in mondays" :class="{ 'active': selectedDate == item }" @click="setDated(item)")
                .date-text {{ $dayjs(item).format('MM/DD') }} - {{ $dayjs(item).add(6, 'days').format('MM/DD') }}
        .league-filter-group
          .all-wrapper
            a.all(href="javascript:void(0);" :class="{ 'active': selectedHighlightLeague == null }" @click="setHighlightLeague()") {{ $t("ui.all") }}
          .league-filter-wrapper
            ul.league-filter
              li.league-tab(v-for="item in highlightLeague" :class="{ 'active': selectedHighlightLeague == item.league_id }" @click="setHighlightLeague(item.league_id)")
                img.league-logo(v-if="item.league_logo_path" :src="item.league_logo_path")
                span {{ getName('name_', item) }}
      #highlight.highlight-content(v-if="list.length > 0")
        .card(v-for="(x, index) in list")
          .league-name(:id="'hightlight-' + x.league_id + index" data-toggle='collapse' :data-target="'#highlight-' + x.league_id+ x.match_id" aria-expanded='itrue' :aria-controls="'highlight-' + x.league_id + x.match_id")
            img.league-logo(v-if="x.league_logo_path" :src='x.league_logo_path')
            span {{ getName('name_', x) }}
          .collapse.show(:id="'highlight-' + x.league_id + x.match_id" :aria-labelledby="'highlight-' + x.league_id + index")
            .highlight-group
              .live-video(v-if="isPlay(x.match_id)")
                player(:src="x.video_link", @add="addPlayer", @remove="removePlayer", @play="playing")
              .live-video.sportsbg1(v-else @click="play(x.match_id)")
                .d-flex.align-items-center.flex-grow-1.justify-content-center(v-if="x.home_logo_path && x.away_logo_path")
                  .team-home.align-items-center.justify-content-end
                    img.team-logo(v-if="x.home_logo_path" :src="x.home_logo_path")
                    .team-name(style="min-height: 30px;") {{ getName('home_name_', x) }}
                  .vs VS
                  .team-away.align-items-center.justify-content-start
                    img.team-logo(v-if="x.away_logo_path" :src="x.away_logo_path")
                    .team-name(style="min-height: 30px;") {{ getName('away_name_', x) }}
                .play-btn
              .match-info
                .d-flex.match-info-team
                  .match-info-team-name
                    .team-logo
                      img(v-if="x.home_logo_path", :src="x.home_logo_path")
                    .name {{ getName('home_name_', x) }}
                  .match-info-score
                    .date-time {{ $dayjs(x.match_time).format('MM/DD') }} {{ $dayjs(x.match_time).format('h:mmA') }}
                    .match-info-wrapper
                      .font-weight-bold {{ x.final_home }} : {{ x.final_away }}
                      .time
                        .label HT
                        .score {{ x.half_home }} : {{ x.half_away }}
                  .match-info-team-name.team02
                    .name {{ getName('away_name_', x) }}
                    .team-logo
                      img(v-if="x.away_logo_path", :src="x.away_logo_path")
              .highlight-text-content(v-if="isRemark")
                .hl-title(v-html="getRemark('remark_', x)")
      template(v-else)
        .message-empty
          .empty.text-center.mt-3
            i.fad.fa-exclamation-triangle
          p.no-message.text-center {{ $t("message.no_information_available") }}
  footerNav
</template>


<script>
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import config from "@/config";
import errors from "@/errors";
import xhr from "@/library/_xhr-game.js";
import mixinExt from "@/library/mixinExt.js";
import mixinMain from "@/library/mixinMain.js";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/library/_xhr-ext";
import player from "@/components/mobile/highlight/player";

import Marquee from "@/components/mobile/mainPanelControl/marquee";

export default {
  components: {
    toolBar,
    footerNav,
    player,
    Marquee
  },
  mixins: [mixinExt, mixinMain],
  data() {
    return {
      countdown: 5,
      mode: 1,
      play1: false,
      play2: false,
      vertical1: false,
      vertical2: false,
      vertical3: false,
      event: {
        action: null,
        radar_id: null,
        channel: null,
        match_id: null,
        sport_id: null,
        market_type: null,
        home_team: null,
        away_team: null,
        working_date: null,
        match_time: null,
        next: null,
        prev: null
      },
      error: null,
      url: "",
      embedded: false,
      liveTV: {
        schedule: [],
        loading: false,
        count: 0,
        matches: {}
      },
      loader: false,
      highlightLeague: [],
      list: [],
      player: [],
      loading: {
        league: false,
        list: false,
      },
      updating: {
        league: false,
      },
      vid: "",
      selectedDate: null,
      selectedHighlightLeague: null,
      selectedLiveNow: "0",
      mondays: [],
      liveSportsList: [],
      highlightList: [],
      isRemark: false,
      isPlayMatchId: null
    };
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    language() {
      return this.$store.getters.language;
    },
    newFeatures() {
      return config.newFeatures;
    },
    vg1() {
      return config.vg1;
    },
  },
  destroyed() {
    EventBus.$off("LIVE_CENTER", this.handleLiveCenter);
    clearInterval(this.getSchedule);
  },
  mounted() {
    // setInterval(this.getSchedule, 60000);
    // this.getSchedule();
    EventBus.$on("LIVE_CENTER", this.handleLiveCenter);
    this.setMode(1)
    var d = new Date(),
      td = new Date(),
      mondays = [];

    d.setDate(1);
    d.setMonth(d.getMonth() - 2);

    // Get the first Monday in the month
    while (d.getDay() !== 1) {
      d.setDate(d.getDate() + 1);
    }

    // Get all the other Mondays in the month
    while (d < td) {
      var pushDate = new Date(d.getTime());
      mondays.push(pushDate);
      d.setDate(d.getDate() + 7);
    }

    this.mondays = mondays.reverse();
  },
  methods: {
    isPlay(e) {
      return this.isPlayMatchId == e;
    },
    play(e) {
      this.isPlayMatchId = e;
    },
    setDated(e) {
      this.selectedDate = e ;
      this.getList();
    },
    setHighlightLeague(e) {
      this.selectedHighlightLeague = e;
      this.getList();
    },
    setLiveNow(e) {
      this.selectedLiveNow = e;
      // if(e == '0') {
      //   var scroll = document.querySelector(".league-filter-wrapper ul li");
      //   scroll.scrollIntoView({
      //     inline: "start"
      //   });
      // }
      this.closeWidget();
      this.clearWidget();
      this.getSchedule();
    },
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    clearWidget(e) {
      // $("#widget-" + this.vid).html('<div id="tv-widget"><div class="wrapper-frame">' + e + "</div></div>");
      $("#widget-" + this.vid).html("");
    },
    handleLiveCenter(e) {
      this.event = e;
      this.error = null;
      this.embedded = false;
      // this.clearWidget('<div class="fa fa-spinner fa-spin"></div>');
      this.mode = 0;
      this.setChannel();
      // if (this.error) {
      //   this.clearWidget(this.error);
      // }
    },
    chooseMatch(e) {
      this.clearWidget()
      var action = "channel";
      this.vid = e.match_id;
      EventBus.$emit("LIVE_CENTER", {
        action: action,
        radar_id: e.radar_id,
        channel: e.channel,
        match_id: e.match_id,
        league_id: e.league_id,
        sport_id: e.sports_type,
        market_type: e.market_type,
        home_team: e.home_name_en,
        away_team: e.away_name_en,
        working_date: e.working_date,
        match_time: e.match_time
      });
    },
    setChannel() {
      var q = this.event;
      if (q.channel == null) {
        this.error = "Please select a channel to watch...";
      } else if (q.channel == "1") {
        this.expanded = true;
        this.launchLiveTV(q.channel, q.match_id, q.sport_id, "1.1.1.1");
      } else {
        this.expanded = true;
        this.getVersion(q).then(
          res => {
            var ip = res;
            this.launchLiveTV(q.channel, q.match_id, q.sport_id, ip);
          },
          err => {
            this.error = err;
          }
        );
      }
    },
    setMode(e) {
      this.mode = e;
      switch(e) {
        case 0:
          this.closeWidget()
          // setInterval(this.getSchedule, 6000)
          this.getSchedule()
          break;
        case 1:
          // clearInterval(this.getSchedule);
          this.closeWidget()
          this.getLeague()
          this.getList()
          break;
      }
    },
    getSchedule(callback) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken
      };

      if (this.liveTV.loading != true) {
        this.liveTV.loading = true;
        service.getLiveList(config.liveTvListUrl(), json).then(
          result => {
            this.liveTV.loading = false;
            if (result) {
              this.feedback.status = result.status;
              if (result.success == true) {
                // var data = result.data;
                var data = [];
                for (var n = 0; n < result.data.length; n++) {
                  // data.push(result.data[n]);
                  if (!this.vg1.includes(result.data[n].sports_type)) {
                    data.push(result.data[n]);
                  }
                }

                this.liveTV.count = data.length;
                var group = data.reduce((r, a) => {
                  r[a.sports_type] = [...(r[a.sports_type] || []), a];
                  return r;
                }, {});
                var gk = Object.keys(group);
                for (var i = 0; i < gk.length; i++) {
                  group[gk[i]].sort((a, b) => {
                    var keyA = new Date(a.match_time),
                      keyB = new Date(b.match_time);
                    if (keyA < keyB) return -1;
                    if (keyA > keyB) return 1;
                  });
                }
                this.liveTV.schedule = group;

                this.liveSportsList = gk;
                var regroup =  Object.keys(group).filter(key => {
                  return (this.selectedLiveNow != "0") ? key == this.selectedLiveNow : key;
                }).reduce((obj, key) => {
                  obj[key] = group[key];
                  return obj;
                }, {});
                this.highlightList = regroup;

                if (callback) {
                  callback(data);
                }
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          err => {
            this.liveTV.loading = false;
            this.feedback.success = false;
            this.feedback.status = errors.request.failed;
            this.$helpers.handleFeedback(err.status);
          }
        );
      }
    },
    resizeWidget(e) {
      var r1 = 234 / 414;
      if (e == 1) {
        r1 = 322 / 414;
      }
      var e1 = $("#widget-" + this.vid);
      e1.height(e1.width() * r1);
    },
    setWidget(e) {
      $("#widget-" + this.vid).html(e);
    },
    openWidget(e) {
      this.resizeWidget(0);
      this.error = "";
      if (e != null && e.channel != null && e.channel > 0 && e.marketId == 3) {
        this.openLiveMatch();
      } else {
        this.closeWidget();
      }
    },
    closeWidget() {
      // this.clearWidget(this.$t("message.match_not_started"))
      this.event = {
        action: null,
        radar_id: null,
        channel: null,
        match_id: null,
        sport_id: null,
        market_type: null,
        home_team: null,
        away_team: null,
        working_date: null,
        match_time: null,
        next: null,
        prev: null
      };
      this.error = "";
      this.url = "";
      this.embedded = false;
    },
    tvLink(e) {
      if (config.vg1.includes(e)) {
        return config.player10Url();
      } else {
        return config.bintuUrl();
      }
    },
    launchLiveTV(ch, mc, sp, ip) {
      var args = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        channel: ch,
        match: mc,
        sports: sp,
        ip: ip
      };
      this.loader = true;
      this.error = "";
      xhr.launchLiveTV(args).then(
        res => {
          this.loader = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              this.embedded = this.url.includes("<iframe");
              if (!this.embedded) {
                this.embedded = this.url.includes("<script");
              }

              if (!this.embedded) {
                // not a iframe link, can be glive or self-hosted live streaming
                if (ch != 1) {
                  var link = this.url + "&compact=1";
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no">';
                  this.setWidget(html);
                } else {
                  // var link = config.bintuUrl() + this.url + "&u=" + args.account_id + "&t=" + args.session_token;
                  var link = this.tvLink(sp) + this.url + "&u=" + args.account_id + "&t=" + args.session_token + "&product=" + sp;
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no">';
                  this.setWidget(html);
                }
              } else {
                // is a iframe link, can be twitch, youtube or any embeded video
                var kns = this.url.replace("www.example.com", window.location.hostname);
                this.setWidget(kns);
              }
            } else {
              this.error = this.$t("error." + res.status);
            }
          }
        },
        err => {
          // console.log(err);
          this.loader = false;
          this.error = this.$t("error." + err.status);
        }
      );
    },
    getVersion(q) {
      const url = "https://api.ipify88.com/";
      const feedback = {
        success: false,
        status: errors.login.failed
      };
      return new Promise((resolve, reject) => {
        this.$http.get(url).then(
          res => {
            resolve(res.bodyText);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    handleMore(source) {
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu1"] = "live";
      mi5["menu3"] = "hdpou";
      mi5["menu0"] = "live";
      mi5["menu2"] = parseInt(source.sports_type);
      this.$store.dispatch("layout/setMenuItems", mi5);
      this.$store.dispatch("layout/setSelectedMatch", source.match_id)
      EventBus.$emit("GET_MATCH2")
      this.$router.push("/more").catch(err => {})
    },
    getName(p, e) {
      var name = e[p + this.language];
      if (name == null || name == "" || !name) {
        name = e[p + "en"];
      }
      return name;
    },
    getRemark(p, e) {
      var name = e[p + this.language];
      if (name == null || name == "" || !name) {
        name = e[p + "en"];
      }
      // var html = name.replace("(", "<div class='badge'>");
      // var html = html.replace(")", "<div class='badge'>");
      var html = "";
      var p = name.split(",");
      for (var i = 0; i < p.length; i++) {
        var b = p[i].split("|");
        if (b.length > 1) {
          this.isRemark = true
          html += "<div class='remark-item'>";
          for (var j = 0; j < b.length; j++) {
            if (j == 0) {
              html += "<div class='remark-detail " + b[j].toLowerCase() + "'>" + b[j] + "</div>";
            } else {
              html += "<div class='remark-detail'>" + b[j] + "</div>";
            }
          }
          html += "</div>";
        } else {
          this.isRemark = false
          html += "<div class='remark-item'>" + b[0] + "</div>";
        }
      }
      return html;
    },
    playing(e) {
      var i = this.player.indexOf(e);
      for (var j = 0; j < this.player.length; j++) {
        if (j != i) {
          this.player[j].pause();
        }
      }
    },
    addPlayer(e) {
      if (this.player.indexOf(e) < 0) {
        this.player.push(e);
      }
    },
    removePlayer(e) {
      var i = this.player.indexOf(e);
      if (i > -1) {
        this.player.splice(i, 1);
      }
    },
    getLeague() {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
      };
      this.loading.league = true;
      service.getAnyList(config.highlightLeagueUrl(), json).then(
        (result) => {
          this.loading.league = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              var data = result.data;
              this.updating.league = true;
              if (data != null && data.length > 0) {
                this.highlightLeague = data;
                // this.selectedHighlightLeague = data[0].league_id;
              } else {
                this.highlightLeague = [];
              }
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        (err) => {
          this.loading.league = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getList(e) {
      var league_id = null;
      var match_date = null;

      if(this.highlightLeague.length > 0) {
        if (!e && this.selectedHighlightLeague) {
          league_id = this.selectedHighlightLeague;
        }

        if (!e && this.selectedDate) {
          match_date = this.$dayjs(this.selectedDate).format("YYYY-MM-DD");
        }
      }

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        league_id: league_id,
        match_date: match_date,
        page_number: 1,
        page_size: 500,
      };
      this.loading.list = true;
      this.list = [];
      service.getAnyList(config.highlightListUrl(), json).then(
        (result) => {
          this.loading.list = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              var data = result.data;
              if (data != null && data.length > 0) {
                this.list = data;
              } else {
                this.list = [];
              }
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        (err) => {
          this.loading.list = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    }
  }
};
</script>
